"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {

    var modalSelector = ".customer-message-detail-detail";
    var subjectCellArray = document.querySelectorAll(".message-subject");
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var subjectCell = _step.value;

            var link = subjectCell.querySelector('a');
            if (!link) return "continue";
            link.addEventListener('click', function (event) {
                return subjectClick(event, subjectCell, link);
            });
        };

        for (var _iterator = (0, _getIterator3.default)(subjectCellArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ret = _loop();

            if (_ret === "continue") continue;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function subjectClick(event, cell, link) {
        event.preventDefault();
        var modal = document.querySelector(modalSelector);
        if (!modal) return;

        modal.classList.remove('hidden');
        document.addEventListener("click", closeOnCLickOutside, false);

        var closeButton = modal.querySelector('.close');
        if (closeButton) closeButton.addEventListener('click', function () {
            modal.classList.add('hidden');
        });

        var subjectValueElement = modal.querySelector('.subject-value');
        if (subjectValueElement && link) subjectValueElement.textContent = link.textContent;
        fillModalValue(modal, cell, '.date-creation-value', '.creation-time');
        fillModalValue(modal, cell, '.body-value', '.message-body');
    }

    function closeOnCLickOutside(event) {
        if (event.target === document.querySelector(modalSelector + " .close") || !event.target.closest(modalSelector + ", .customer-message-link")) {
            var modal = document.querySelector(modalSelector);
            modal.classList.add('hidden');
            document.removeEventListener("click", closeOnCLickOutside);
        }
    }

    function fillModalValue(modal, element, modalElementSelector, cellElementSelector) {
        var creationDateElement = modal.querySelector(modalElementSelector);
        var creationDateCell = element.parentElement.querySelector(cellElementSelector);
        if (creationDateElement && creationDateCell) creationDateElement.innerHTML = creationDateCell.innerHTML;
    }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/customerMessagesDetail.js
// module id = 935
// module chunks = 0